import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Perspective02 = function Perspective02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 5v14.0001m-6-15v16m-7-8h18M3 5.9892V18.011c0 1.364 0 2.046.2813 2.5188a2 2 0 0 0 1.093.8768c.5225.172 1.1883.0241 2.5199-.2718l11.6-2.5778c.8941-.1987 1.3412-.298 1.6749-.5384a2 2 0 0 0 .6686-.8336C21 16.807 21 16.3491 21 15.4331v-6.866c0-.916 0-1.374-.1623-1.7519a2 2 0 0 0-.6686-.8335c-.3337-.2404-.7808-.3398-1.6749-.5385l-11.6-2.5778c-1.3316-.2959-1.9973-.4438-2.5199-.2717a2 2 0 0 0-1.093.8768C3 3.9432 3 4.6252 3 5.9892"
    })
  }));
};
export default Perspective02;